module.exports = __webpack_public_path__ + "static/media/halo-fix.2a957a22.webp";